module.exports = __webpack_public_path__ + "img/bgc7.5e0fdc9d.png";